var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-icon',{style:({ color: _vm.color }),attrs:{"icon":_vm.icon,"width":"20px","height":"20px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }